import React from 'react';
import Fullscreen from 'wix-rich-content-fullscreen';
import type { DraftContent } from '../../index';
import { isFunction } from 'lodash';

interface Props {
  initialState: DraftContent;
  isOpen: boolean;
  index: number;
  images: Record<string, unknown>[];
  onClose: () => void;
  dataHook: string;
  isMobile: boolean;
  backgroundColor: string;
  foregroundColor: string;
  container?: HTMLElement | (() => HTMLElement | null);
}

const ViewerModal: React.FC<Props> = ({
  index,
  isOpen,
  images,
  onClose,
  isMobile,
  backgroundColor,
  foregroundColor,
  container,
}) => {
  return (
    <Fullscreen
      isOpen={isOpen}
      images={images}
      onClose={onClose}
      isMobile={isMobile}
      index={index}
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
      target={isFunction(container) ? container() : container}
    />
  );
};

export default ViewerModal;
